import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Icon, { IconSizes, IconVariants } from '../../../../components/foundations/Icon';
import FormattedText from '../../../../components/utilities/FormattedText';
import InsightTable from './InsightTable';
import CollapsableRow from '../../../../collapsableRow/CollapsableRow';
import css from './InsightRow.css';
import { CategoryToTitle, CategoryToIcon } from '../consts';

const CATEGORY_CLASSNAMES = [css.icon1, css.icon2, css.icon3, css.icon4];

const InsightRow = ({ category, data, insightIndex, expandedCategory, onCategoryClick }) => {
    const { explanation = '', table = null, comments = '' } = data || {};
    const [isExpanded, setIsExpanded] = useState(false);

    const PREVIEW_CHAR_LIMIT = 500;
    const hasLongExplanation = explanation.length > PREVIEW_CHAR_LIMIT;

    const handleToggleExpand = e => {
        e.stopPropagation();
        setIsExpanded(!isExpanded);
    };

    const titleElement = (
        <div className={css.titleContainer}>
            <Icon
                name={CategoryToIcon[category] || 'file-text'}
                size={IconSizes.MEDIUM}
                className={CATEGORY_CLASSNAMES[insightIndex] || css.icon1}
                interactive={false}
            />
            <span className={css.title}>{CategoryToTitle[category] || 'Untitled'}</span>
        </div>
    );

    return (
        <CollapsableRow
            onClick={() => onCategoryClick(category)}
            expanded={expandedCategory === category}
            title={titleElement}
        >
            <div className={css.insightContainer}>
                {explanation && (
                    <div className={css.explanationSection}>
                        {!hasLongExplanation || isExpanded ? (
                            explanation.split('\n').map(line => (
                                <div key={`explanation-line-${line}`} className={css.customBreak}>
                                    <FormattedText text={line} />
                                </div>
                            ))
                        ) : (
                            <div className={css.customBreak}>
                                <FormattedText text={`${explanation.substring(0, PREVIEW_CHAR_LIMIT)}...`} />
                                <span className={css.showMoreLess} onClick={handleToggleExpand}>
                                    Show More
                                </span>
                            </div>
                        )}

                        {hasLongExplanation && isExpanded && (
                            <span className={css.showMoreLess} onClick={handleToggleExpand}>
                                Show Less
                            </span>
                        )}
                    </div>
                )}
                {table && <InsightTable table={table} category={category} />}
                {comments && (
                    <div className={css.commentsContainer}>
                        <Icon
                            name="info-circle"
                            size={IconSizes.X_SMALL}
                            variant={IconVariants.ACTIVE}
                            className={css.infoIcon}
                        />
                        <span className={css.comments}>{comments}</span>
                    </div>
                )}
            </div>
        </CollapsableRow>
    );
};

InsightRow.propTypes = {
    category: PropTypes.string.isRequired,
    data: PropTypes.object,
    insightIndex: PropTypes.number.isRequired,
    expandedCategory: PropTypes.string,
    onCategoryClick: PropTypes.func.isRequired,
};

export default InsightRow;
